import { render, staticRenderFns } from "./tyyDoubleTestRecord.vue?vue&type=template&id=50ce0b48&"
import script from "./tyyDoubleTestRecord.vue?vue&type=script&lang=js&"
export * from "./tyyDoubleTestRecord.vue?vue&type=script&lang=js&"
import style0 from "./tyyDoubleTestRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports